export async function getConfig() {
    const publicUrl = (process.env.PUBLIC_URL ?? "").replace(/\/$/, "");
    const url = `${window.location.origin}${publicUrl}/config.json`;
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(
            `Failed to load config.json (${response.status} ${response.statusText}): ${url}`
        );
    }
    return response.json();
}
